import React, { useState } from "react";
import silider1 from "./assets/SLIDER OF IMAGES WITH PRESIDENT BELOW MOHAN YADAV/32.png";
import silider2 from "./assets/SLIDER OF IMAGES WITH PRESIDENT BELOW MOHAN YADAV/33.png";
import silider3 from "./assets/SLIDER OF IMAGES WITH PRESIDENT BELOW MOHAN YADAV/34.png";
import silider4 from "./assets/SLIDER OF IMAGES WITH PRESIDENT BELOW MOHAN YADAV/35.png";

const Slider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const closeSlider = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;
  const slides = [
    {
      src: silider1,
      alt: "Mrs. Dipali Arora presenting a device to Honorable President Droupadi Murmu during a ceremony with people in the background",
      caption: "Our Founder Mrs. Dipali Arora with ",
      captionHighlight: "Hon. President Droupadi Murmu",
    },
    {
      src: silider2,
      alt: "Staff member appreciated by Honorable President involved in flower arrangement with other staff members around",
      caption: "Hon’ble President staff, appreciating their efforts",
      captionHighlight: "",
    },
    {
      src: silider3,
      alt: "Honorable President interacting with a community during an event with smiling faces",
      caption: "Hon’ble President with local community at event",
      captionHighlight: "",
    },
    {
      src: silider4,
    },
  ];
  return (
    <>
      <div className="overlay">
       
        <div
          className="slider-container"
          role="region"
          aria-label="Image carousel"
        >
          <button
            aria-label="Previous slide"
            onClick={prevSlide}
            className="nav-btn left"
          >
            ‹
          </button>
          <div className="slides-wrapper">
            {slides.map((slide, index) => {
              let className = "slide";
              if (index === currentIndex) className += " active";
              else if (
                index ===
                (currentIndex === 0 ? slides.length - 1 : currentIndex - 1)
              )
                className += " left-slide";
              else if (
                index ===
                (currentIndex === slides.length - 1 ? 0 : currentIndex + 1)
              )
                className += " right-slide";
              else className += " hidden-slide";

              return (
                <figure key={index} className={className}>
                  <img
                    src={slide.src}
                    alt={slide.alt}
                    loading="lazy"
                    onError={(e) => (e.target.style.display = "none")}
                  />
                </figure>
              );
            })}
          </div>
          <button
            aria-label="Next slide"
            onClick={nextSlide}
            className="nav-btn right"
          >
            ›
          </button>
        </div>
      </div>

      <style>{`
        .overlay {
          
          top: 0; left: 0; right: 0; bottom: 0;
          background-color:rgb(18, 58, 47); /* dark green */
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
          padding: 1rem;
          overflow: hidden;
        }
        .close-btn {
          position: absolute;
          top: 1rem;
          left: 50%;
          transform: translateX(-50%);
          font-size: 2rem;
          background: rgba(255 255 255 / 0.2);
          border: none;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          color: #fff;
          cursor: pointer;
          transition: background-color 0.3s ease;
          z-index: 10;
          display: flex;
          justify-content: center;
          align-items: center;
          line-height: 1;
        }
        .close-btn:hover {
          background: rgba(255 255 255 / 0.5);
        }
        .slider-container {
          position: relative;
          max-width: 720px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          user-select: none;
        }
        .nav-btn {
          background: rgba(255 255 255 / 0.3);
          border: none;
          border-radius: 50%;
             width: 70px;
    height: 56px;
          font-size: 2rem;
          color: #07301c;
          font-weight: bold;
          cursor: pointer;
          z-index: 5;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: background-color 0.3s ease;
        }
        .nav-btn:hover {
          background: rgba(255 255 255 / 0.8);
        }
        .nav-btn.left {
          margin-right: 1rem;
        }
        .nav-btn.right {
          margin-left: 1rem;
        }
        .slides-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 480px;
          perspective: 1500px;
          overflow: visible;
        }
       figure {
  margin: 0;
  position: absolute;
  top: 0; bottom: 0;
  opacity: 0;
  transition: all 0.5s ease;
  box-sizing: border-box;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  background: transparent;
  text-align: center;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  color: #07301c;
  font-size: 1.2rem;
  max-width: 100%;
  user-select: none;
}

        figure img {
          border-radius: 16px;
          width: 100%;
          height: auto;
          max-height: 295px;
          object-fit: contain;
          pointer-events: none;
          user-select: none;
              transform: scale(1.6);
        }
        figcaption {
          margin-top: 1rem;
          font-weight: 500;
        }
        figcaption strong {
          font-weight: 700;
        }
        .slide.active {
          position: relative;
          opacity: 1;
          max-width: 720px;
          box-shadow: 0 10px 35px rgb(0 0 0 / 0.9);
          transform: translateX(0) scale(1) perspective(1500px) rotateY(0deg);
          z-index: 10
          transform: scale(1.1);
        }
        .slide.left-slide {
          opacity: 0.45;
          max-width: 480px;
          transform: translateX(-310px) scale(0.55) perspective(1500px) rotateY(35deg);
          z-index: 7;
        }
        .slide.right-slide {
          opacity: 0.45;
          max-width: 480px;
          transform: translateX(310px) scale(0.55) perspective(1500px) rotateY(-35deg);
          z-index: 7;
        }
        .slide.hidden-slide {
          opacity: 0;
          pointer-events: none;
          z-index: 1;
        }
        /* Responsive */
        @media (max-width: 768px) {
          .slide.active {
            max-width: 90vw;
          }
          .slide.left-slide, .slide.right-slide {
            display: none;
          }
          .nav-btn.left {
            margin-right: 0.5rem;
          }
          .nav-btn.right {
            margin-left: 0.5rem;
          }
        }
      `}</style>
    </>
  );
};

export default Slider;
